const { isTablet, debounceFunction } = GLOBAL

export default function multiLevelMenu(obj) {
	let state = { open: false, delay: 150 }

	const sidebar = document.querySelector('.sidebar')
	if (!sidebar) return
	if (!obj) return
	const body = document.body

	const svgAdicionar = `<svg><use xlink:href="#icon_add"></use></svg>`
	const svgList = `<svg><use xlink:href="#icon_list"></use></svg>`
	const svgArrow = `<svg class="icon group-hover:opacity-100 icon-arrow"><use xlink:href="#icon_arrow_left"></use></svg>`
	const iconBack = `<svg class="icon-back group-hover:opacity-100 icon-arrow h-32 w-32"><use xlink:href="#icon_back_arrow"></use></svg>`

	const tipyAdicionar = 'data-tippy-content="Adicionar"'
	const tipyList = 'data-tippy-content="Lista"'

	const fundo = document.querySelector('.nav-fundo ')
	const itensLV0 = sidebar.querySelectorAll(
		'[js-menu-lista]  > li[js-lista-name] '
	)
	const toogle = document.querySelector('[js-menu-toggle]')

	// Titulo
	const templateModuleName = (name, icon) =>
		`<li class='module-name'>${icon && !isTablet ? icon.outerHTML : ''} ${
			isTablet ? iconBack : ''
		}  ${name}<li>`

	// Me de o menu pertencente
	const getStaticMenu = (slug) =>
		document.querySelector(`[js-menu-lista] [js-lista-name='${slug}']`)

	// Popula os leveis do menu
	const populateMenuLevel = (itemMenu, submenu, name, svg) => {
		const templateSubMenu = templateLevelMenu(submenu)
		const templateItems = submenu.items.map(templateItensSubmenu)
		templateSubMenu.innerHTML = templateItems.join('')
		templateSubMenu.insertAdjacentHTML(
			'afterbegin',
			templateModuleName(name, svg)
		)
		itemMenu.appendChild(templateSubMenu)
		itemMenu.classList.add('have-submenu')
	}

	// Template das liZ
	const templateItensSubmenu = (item) => {
		const { name, link, list, adicionar, slug, submenu } = item
		// console.log(item)
		return `
				<li class="group" js-lista-name='${slug}' ${submenu ? `data-submenu` : ''}>
					<div class="item-wrapper">
						<a ${link ? `href="${link}"` : ''} class='item'> ${name}	</a>
						${
							adicionar
								? `<a ${tipyAdicionar} class='adicionar' href="${adicionar}">${svgAdicionar}</a>`
								: ''
						}
						${list ? `<a ${tipyList} class='lista' href="${list}">${svgList}</a>` : ''}
						${submenu ? svgArrow : ''}
					</div>
				</li>`
	}

	// Template dos sublevel
	const templateLevelMenu = (submenu) => {
		const div = document.createElement('ul')
		div.setAttribute('data-level', submenu.level)
		div.classList.add('submenu')
		return div
	}

	//Cria subMenus
	const createSubMenus = ({ slug, submenu, name }) => {
		const itemMenu1 = getStaticMenu(slug)
		const svg = itemMenu1.querySelector('svg').cloneNode(true)
		svg.style.setProperty('--cor-1', 'white')

		if (!submenu) return
		populateMenuLevel(itemMenu1, submenu, name, svg)

		submenu.items.forEach(({ slug, submenu, name }) => {
			const itemMenu2 = getStaticMenu(slug)

			if (!submenu) return
			populateMenuLevel(itemMenu2, submenu, name)

			submenu.items.forEach(({ slug, submenu, name }) => {
				const itemMenu3 = getStaticMenu(slug)

				if (!submenu) return
				populateMenuLevel(itemMenu3, submenu, name)
			})
		})
	}

	const handleClickFundo = () => {
		itensLV0.forEach((i) => i.classList.remove('active'))
		body.classList.remove('menu-ativo')
		toogleMenu()
	}

	const handleClickItem = (i) => (e) => {
		if (e.isTrusted && (e.target.tagName == 'A' || e.target.closest('a'))) {
			return
		}
		setTimeout(() => sidebar.classList.add('animou'), 200) //add classe para animar apenas uma vez
		body.classList.add('menu-ativo') //add classe para mostrar o fundo do menu
		itensLV0.forEach((i) => i.classList.remove('active')) //remove ativo tds outros
		body.classList.remove('dont-open-submenu') // remove a classe que impede que o submenu seja aberto
		i.classList.toggle('active')
	}

	const toogleMenu = (e) => {
		//calback hover menu
		//funcao do jquery que me da mais certeza c o menu esta aberto ou n
		if (!isTablet) {
			if (body.classList.contains('menu-ativo')) return
			state.open = !$(sidebar).is(':hover')
		}
		// console.log(state.open);
		if (state.open) {
			// if(e)

			body.classList.add('menu-closed')
			body.classList.add('dont-open-submenu')
			sidebar.classList.remove('animou')

			if (isTablet) {
				state.open = false
				body.classList.remove('menu-ativo')
			}
		} else {
			body.classList.remove('menu-closed')
			body.classList.remove('menu-ativo')

			if (isTablet) {
				state.open = true
			}
		}
	}

	// const showLevelActive = (e) => {
	// 	const level = Number(e.target.closest(".have-submenu")?.querySelector(".submenu").dataset.level) + 1
	// 	console.log(level);
	// 	if (level === 3) sidebar.setAttribute("data-radius", "3")
	// 	if (level === 2) sidebar.setAttribute("data-radius", "2")
	// 	if (level === 1) sidebar.setAttribute("data-radius", "1")
	// }

	const backLevel = (e) => {
		setTimeout(() => itensLV0.forEach((i) => i.classList.remove('active')), 100)
	}

	const events = () => {
		itensLV0.forEach((i) => i.addEventListener('click', handleClickItem(i)))

		if (isTablet) {
			toogle?.addEventListener('click', toogleMenu)
			document
				.querySelectorAll('.icon-back')
				.forEach((i) => i.addEventListener('click', backLevel))
		} else {
			sidebar.addEventListener(
				'mouseenter',
				debounceFunction(toogleMenu, state.delay)
			)
			sidebar.addEventListener('mouseout', toogleMenu)
			fundo.addEventListener('click', handleClickFundo)
		}

		// sidebar.addEventListener("mousemove", showLevelActive)
	}

	function agruparDropdownsPorGrupo() {
		const menu = document.querySelector('[js-menu-lista]')
		if (!menu) return

		// Busca todos os li com data-menu-group
		const itens = Array.from(menu.querySelectorAll('li[data-menu-group]'))

		// Agrupa por valor do atributo
		const grupos = {}
		itens.forEach((li) => {
			const grupo = li.getAttribute('data-menu-group')
			if (!grupos[grupo]) grupos[grupo] = []
			grupos[grupo].push(li)
		})

		// Remove os itens do menu principal
		itens.forEach((li) => menu.removeChild(li))

		// Cria os dropdowns e insere no início do menu
		const dropdowns = []
		Object.entries(grupos).forEach(([grupo, itensGrupo]) => {
			const { liDropdown, ulDropdown } = criarEstruturaDropdown(grupo)
			itensGrupo.forEach((item) => ulDropdown.appendChild(item))
			dropdowns.push(liDropdown)
		})

		// Insere todos os dropdowns no início do menu
		dropdowns.reverse().forEach((dropdown) => {
			menu.insertBefore(dropdown, menu.firstChild)
		})
	}

	function criarEstruturaDropdown(grupo) {
		const liDropdown = document.createElement('li')
		liDropdown.className = 'sidebar-group-dropdown'

		const titulo = document.createElement('a')
		titulo.href = '#'
		titulo.className = 'sidebar-nav-button'
		titulo.dataset.fullname = grupo
		const lastWord = grupo.trim().split(' ').pop()
		titulo.dataset.shortname = lastWord
		titulo.textContent = grupo

		const svgSeta = document.createElement('span')
		svgSeta.className = 'sidebar-dropdown-arrow'
		svgSeta.innerHTML = `<svg class="w-16 h-16"><use xlink:href="#icon_arrow_up"></use></svg>`
		titulo.appendChild(svgSeta)

		const ulDropdown = document.createElement('ul')
		ulDropdown.className = 'sidebar-drop-down closed'

		titulo.addEventListener('click', function (e) {
			e.preventDefault()
			ulDropdown.classList.toggle('closed')
			svgSeta.classList.toggle('open', !ulDropdown.classList.contains('closed'))
		})

		liDropdown.appendChild(titulo)
		liDropdown.appendChild(ulDropdown)

		// Troca nome quando sidebar está minimizado
		function updateDropdownName() {
			// Atualiza só o texto, mantendo o SVG
			const texto = document.body.classList.contains('menu-closed')
				? titulo.dataset.shortname
				: titulo.dataset.fullname

			// Se já existe um nó de texto, atualiza; senão, cria
			if (
				titulo.childNodes.length > 0 &&
				titulo.childNodes[0].nodeType === Node.TEXT_NODE
			) {
				titulo.childNodes[0].textContent = texto
			} else {
				titulo.insertBefore(document.createTextNode(texto), titulo.firstChild)
			}
		}

		updateDropdownName()
		document.body.addEventListener('classChange', updateDropdownName)
		// fallback para mudanças via JS
		const observer = new MutationObserver(updateDropdownName)
		observer.observe(document.body, {
			attributes: true,
			attributeFilter: ['class'],
		})

		return { liDropdown, ulDropdown }
	}

	function abrirGrupoMenuPorAbaAtiva() {
		const menu = document.querySelector('[js-menu-lista]')
		if (!menu) return

		const SAP_GROUP = 'Gestão SAP'
		const pathnameStart = window.location.pathname

		const isRoot = pathnameStart === '/' || pathnameStart === ''

		if (isRoot) {
			const dropdown = Array.from(
				menu.querySelectorAll('.sidebar-group-dropdown')
			).find(
				(li) =>
					li.querySelector('.sidebar-nav-button')?.dataset.fullname ===
					SAP_GROUP
			)
			if (dropdown) {
				const ulDropdown = dropdown.querySelector('.sidebar-drop-down')
				const svgSeta = dropdown.querySelector('.sidebar-dropdown-arrow')
				ulDropdown.classList.remove('closed')
				svgSeta.classList.add('open')
			}

			return // Não executa o restante da lógica na primeira visita
		}

		// Encontra o item ativo (pode ser por URL ou classe, ajuste conforme seu HTML)
		const pathname = window.location.pathname
		const liAtivo = Array.from(menu.querySelectorAll('li[js-lista-name]')).find(
			(li) => {
				const link = li.querySelector('a.menu-item')

				return link && link.href && link.href.includes(pathname)
			}
		)

		if (liAtivo) {
			const grupo = liAtivo.getAttribute('data-menu-group')
			if (grupo) {
				// Procura o dropdown do grupo e abre
				const dropdown = Array.from(
					menu.querySelectorAll('.sidebar-group-dropdown')
				).find(
					(li) =>
						li.querySelector('.sidebar-nav-button')?.dataset.fullname === grupo
				)
				if (dropdown) {
					const ulDropdown = dropdown.querySelector('.sidebar-drop-down')
					const svgSeta = dropdown.querySelector('.sidebar-dropdown-arrow')
					ulDropdown.classList.remove('closed')
					svgSeta.classList.add('open')
				}
			}
		}
	}

	function init() {
		agruparDropdownsPorGrupo()
		obj.forEach(createSubMenus)
		events()
		abrirGrupoMenuPorAbaAtiva()
		return this
	}

	return {
		init,
		toogleMenu,
	}
}
